module.exports = __webpack_public_path__ + "img/partner_jck_04@2x.828c7779.png";